/**
 * Applies HR / TPRM / audit organizational impact to per-tick simulation metrics.
 */
import type {
  AuditStatus,
  ComplianceChecklist,
  Employee,
  Vendor,
} from '../../../types';
import {
  calculateTotalOrgImpact,
  type OrgImpactMetrics,
} from '../../../utils/orgImpactCalculator';

export interface OrgTickData {
  employees: Employee[];
  vendors: Vendor[];
  audits: AuditStatus[];
  checklists: ComplianceChecklist[];
  workflows: unknown[];
}

export interface OrgImpactAdjustment {
  complianceDelta: number;
  threatDelta: number;
  metrics: OrgImpactMetrics;
}

export class OrgImpactApplier {
  apply(netComp: number, dailyThreat: number, orgData: OrgTickData): OrgImpactAdjustment {
    const metrics = calculateTotalOrgImpact(
      orgData.employees,
      orgData.vendors,
      orgData.audits,
      orgData.checklists,
      orgData.workflows,
    );

    const complianceDelta = metrics.totalOrgImpact.complianceModifier;
    const threatDelta = metrics.totalOrgImpact.threatModifier;

    return {
      complianceDelta,
      threatDelta,
      metrics,
    };
  }

  applyToTickMetrics(
    netComp: number,
    dailyThreat: number,
    orgData: OrgTickData,
  ): { netComp: number; dailyThreat: number; adjustment: OrgImpactAdjustment } {
    const adjustment = this.apply(netComp, dailyThreat, orgData);

    return {
      netComp: netComp + adjustment.complianceDelta,
      dailyThreat: dailyThreat + adjustment.threatDelta,
      adjustment,
    };
  }
}